import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StaiSessionPurchased = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/stai-talent/${notification.data?.session_id}`);
  };
  return (
    <Box onClick={handleClick} sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {t("stai_session_purchased.title", {
            ns: "notification",
            userName: notification?.data?.username ?? "",
          })}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {t("stai_session_purchased.message", {
            ns: "notification",
            userName: notification?.data?.username ?? "",
          })}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StaiSessionPurchased;
